<template>
  <div>
    <NuxtLoadingIndicator color="black" />
    <LazyConsentBanner v-if="cookieBannerVisible" />
    <ConsentModal />
    <div
      v-if="
        isFeatureEnabled('showRedirectToBrowserLanguageBanner') &&
        isUpdateLanguageBarShown
      "
      class="w-full bg-black py-5"
    >
      <div class="container flex justify-between gap-2 text-white">
        <div class="flex items-center gap-2">
          <p class="font-pragmatica-ext font-bold">
            <span v-if="browserLanguage === 'cs' || browserLanguage === 'sk'">
              Chcete zobrazit místní variantu stránky?
            </span>
            <span v-else-if="browserLanguage === 'fr'">
              Voulez-vous voir la version locale du site?
            </span>
            <span v-else-if="browserLanguage === 'de'">
              Möchten Sie die lokale Version der Website sehen?
            </span>
            <span v-else>
              Do you want to see the local version of the site?
            </span>
          </p>
          <NuxtLink
            :to="
              $localePath(
                { path: route.path, hash: route.hash, query: route.query },
                ['cs', 'fr', 'de', 'en'].includes(browserLanguage)
                  ? (browserLanguage as 'cs' | 'fr' | 'de' | 'en')
                  : 'en'
              )
            "
          >
            <p class="font-pragmatica-ext font-bold">
              <span v-if="browserLanguage === 'cs' || browserLanguage === 'sk'">
                Přejít
              </span>
              <span v-else-if="browserLanguage === 'fr'">Aller</span>
              <span v-else-if="browserLanguage === 'de'">Gehen</span>
              <span v-else>Go</span>
            </p>
          </NuxtLink>
        </div>
        <button
          class="font-pragmatica-ext font-bold underline"
          @click="hideLanguageBar()"
        >
          <IconClose invert />
        </button>
      </div>
    </div>
    <UNotifications
      :ui="{
        position: 'top-0 !z-[105] bottom-[unset] left-1/2 -translate-x-1/2',
      }"
    />
    <NotificationNotifications />
    <UiRegisterNotification />
    <UiAlert
      :show="store.isVisible"
      :messages="store.messages"
      @close="store.setVisible(false)"
    />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { useAlertsStore } from '~/stores/alerts'

const { isFeatureEnabled } = useFeatureFlags()

const route = useRoute()

const { t } = useI18n()

const { isUpdateLanguageBarShown, browserLanguage, hideLanguageBar } =
  useUpdateLanguage()

const head = useLocaleHead()

useServerHead({
  htmlAttrs: head.value.htmlAttrs,
  link: head.value.link,
  meta: head.value.meta,
})

useScripts()
useScrollControl()

const store = useAlertsStore()
const { defaultOgImage } = useOgImage()

useSeoMeta({
  title: 'LD Seating',
  description: t('pages.index.meta.description'),
  ogImage: defaultOgImage,
})

const cookieBannerVisible = ref(false)

onMounted(() => {
  // TODO: Drop in future
  localStorage['nuxt-color-mode'] = 'light'
  cookieBannerVisible.value = true
})
</script>

<style lang="scss">
::selection {
  background-color: #000;
  color: #fff;
}

.bg-black {
  ::selection {
    background-color: #fff;
    color: #000;
  }
}

@font-face {
  font-family: 'Pragmatica';
  src:
    local('Pragmatica Book'),
    local('Pragmatica-Book'),
    url('/fonts/pragmatica-book.woff2') format('woff2'),
    url('/fonts/pragmatika-book.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Pragmatica';
  src:
    local('Pragmatica Bold'),
    local('Pragmatica-Bold'),
    url('/fonts/pragmatica-bold.woff2') format('woff2'),
    url('/fonts/pragmatika-bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Pragmatica Ext';
  src:
    local('Pragmatica Ext Book'),
    local('PragmaticaExt-Book'),
    url('/fonts/pragmatica-ext-book.woff2') format('woff2'),
    url('/fonts/pragmatica-ext-book.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Pragmatica Ext';
  src:
    local('Pragmatica Ext Bold'),
    local('PragmaticaExt-Bold'),
    url('/fonts/pragmatica-ext-bold.woff2') format('woff2'),
    url('/fonts/pragmatica-ext-bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

.sl-overlay {
  background-color: black !important;
}

.sl-wrapper .sl-close {
  color: white !important;
}

.sl-wrapper .sl-navigation button {
  color: white !important;
}
</style>
